export default "__VITE_ASSET__CyBCTFnd__"